import styled, { createGlobalStyle, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`

const c = {
  bg: '#0a0c0f', bg2: '#111318', bg3: '#181c23', bg4: '#1e2330',
  bdr: '#1f2430', bdr2: '#2a3040',
  acc: '#00e5a0', acc2: '#00b87a',
  adim: 'rgba(0,229,160,.08)', adim2: 'rgba(0,229,160,.18)',
  txt: '#e8ecf0', txt2: '#8a95a3', txt3: '#5a6370',
  warn: '#f59e0b', danger: '#ef4444', info: '#3b82f6',
  mono: "'Space Mono',monospace", sans: "'DM Sans',sans-serif",
}

// Cores por status do pedido (4 status novos)
export const STATUS_COLORS = {
  aguardando_recebimento: { bg: 'rgba(138,149,163,.15)', border: '#5a6370', text: '#a8b3c1' }, // cinza
  coletado_parcial:       { bg: 'rgba(245,158,11,.15)',  border: '#f59e0b', text: '#fbbf24' }, // amarelo
  coletado:               { bg: 'rgba(59,130,246,.15)',  border: '#3b82f6', text: '#60a5fa' }, // azul
  embarcado:              { bg: 'rgba(0,229,160,.15)',   border: '#00b87a', text: '#00e5a0' }, // verde
  entregue:               { bg: 'rgba(0,184,122,.18)',   border: '#00b87a', text: '#34d399' }, // verde escuro
  nao_embarcado:          { bg: 'rgba(239,68,68,.18)',   border: '#ef4444', text: '#fca5a5' }, // vermelho
}
export const STATUS_LABEL = {
  aguardando_recebimento: 'Aguardando Recebimento',
  coletado_parcial:       'Coletado Parcial',
  coletado:               'Coletado',
  embarcado:              'Embarcado',
  entregue:               'Entregue',
  nao_embarcado:          'Não Embarcado',
}

export const GlobalOrdersStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');
`

export const PageWrap = styled.div`
  background:${c.bg}; color:${c.txt}; font-family:${c.sans};
  height:100vh; display:flex; flex-direction:column; overflow:hidden;
`

export const Topbar = styled.div`
  background:${c.bg2}; border-bottom:1px solid ${c.bdr};
  padding:10px 16px; height:48px;
  display:flex; align-items:center; gap:14px; flex-shrink:0;
  h2 { font-size:13px; font-weight:600; color:${c.txt}; }
  .crumb { font-size:11px; color:${c.txt3}; }
`

export const Body = styled.div`flex:1; display:flex; flex-direction:column; min-height:0;`

// ─── Stats Row ─────────────────────────────────────────────────────────────
export const StatsRow = styled.div`
  display:grid; grid-template-columns: repeat(7, 1fr); gap:10px;
  padding:14px 20px; background:${c.bg2}; border-bottom:1px solid ${c.bdr};
  flex-shrink:0;
  @media (max-width: 1100px) { grid-template-columns: repeat(4, 1fr); }
  @media (max-width: 700px)  { grid-template-columns: repeat(2, 1fr); }
`
export const StatCard = styled.div`
  background:${c.bg3}; border:1px solid ${c.bdr}; border-radius:8px;
  padding:10px 14px;
  display:flex; flex-direction:column; gap:2px;
  border-left:3px solid ${({ $variant }) =>
    $variant === 'aguardando_recebimento' ? '#5a6370' :
    $variant === 'coletado_parcial'       ? '#f59e0b' :
    $variant === 'coletado'               ? '#3b82f6' :
    $variant === 'embarcado'              ? '#00e5a0' :
    $variant === 'entregue'               ? '#00b87a' :
    $variant === 'nao_embarcado'          ? '#ef4444' : c.acc};
  .l { font-size:10px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em; }
  .v { font-family:${c.mono}; font-size:20px; font-weight:700;
       color:${({ $variant }) =>
         $variant === 'aguardando_recebimento' ? c.txt :
         $variant === 'coletado_parcial'       ? '#fbbf24' :
         $variant === 'coletado'               ? '#60a5fa' :
         $variant === 'embarcado'              ? c.acc      :
         $variant === 'entregue'               ? '#34d399'  :
         $variant === 'nao_embarcado'          ? '#fca5a5'  : c.txt}; }
`

// ─── Toolbar ───────────────────────────────────────────────────────────────
export const Toolbar = styled.div`
  display:flex; align-items:center; gap:10px; padding:12px 20px;
  background:${c.bg2}; border-bottom:1px solid ${c.bdr}; flex-shrink:0;
  flex-wrap:wrap;
`
export const Search = styled.input`
  flex:1; max-width:360px; min-width:200px; background:${c.bg3};
  border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:9px 12px; font-size:12px; font-family:${c.sans}; outline:none;
  &:focus { border-color:${c.acc}; }
  &::placeholder { color:${c.txt3}; }
`
export const FilterChips = styled.div`
  display:flex; align-items:center; gap:6px; flex-wrap:wrap;
`
export const FilterChip = styled.button`
  background:${({ $active }) => $active ? c.adim2 : 'transparent'};
  border:1px solid ${({ $active }) => $active ? c.acc2 : c.bdr2};
  color:${({ $active }) => $active ? c.acc : c.txt2};
  border-radius:14px; padding:5px 12px;
  font-size:11px; font-weight:500; cursor:pointer; transition:.12s;
  display:inline-flex; align-items:center; gap:6px;
  font-family:${c.sans}; line-height:1;
  &:hover { border-color:${c.acc}; color:${c.acc}; }
`
export const FilterChipCount = styled.span`
  font-family:${c.mono}; font-size:10px; font-weight:700; opacity:.8;
`
export const RefreshBtn = styled.button`
  background:${c.bg3}; border:1px solid ${c.bdr2}; color:${c.txt2};
  padding:8px 12px; border-radius:7px; font-size:11px; cursor:pointer;
  transition:.15s; font-family:${c.sans};
  &:hover { border-color:${c.acc}; color:${c.acc}; }
  &:disabled { opacity:.5; cursor:not-allowed; }
`
export const ImportBtn = styled.button`
  background:${c.acc}; border:none; color:#000;
  padding:9px 16px; border-radius:8px; cursor:pointer;
  font-size:12px; font-weight:700; font-family:${c.sans};
  transition:.15s; margin-left:auto;
  display:inline-flex; align-items:center; gap:6px;
  &:hover { filter:brightness(1.1); }
  &:disabled { opacity:.5; cursor:not-allowed; }
`
export const BulkActions = styled.div`
  display:flex; align-items:center; gap:8px; padding:8px 20px;
  background:${c.adim}; border-bottom:1px solid ${c.acc2};
  font-size:11px; color:${c.acc};
  animation: ${fadeIn} .15s ease;
  strong { font-family:${c.mono}; }
`
export const BulkBtn = styled.button`
  background:transparent; border:1px solid ${c.acc2}; color:${c.acc};
  padding:5px 12px; border-radius:6px; font-size:11px; cursor:pointer;
  font-weight:600; transition:.12s; font-family:${c.sans};
  &:hover { background:${c.acc}; color:#000; }
  &:disabled { opacity:.5; cursor:not-allowed; }
  &.ghost { border-color:${c.bdr2}; color:${c.txt3}; &:hover { background:${c.bg4}; color:${c.txt}; } }
`

// ─── Tabela (CSS Grid — não mais display:table) ─────────────────────────────
// Grid columns compartilhadas entre header e linhas pra alinhar perfeitamente.
// Ordem: [checkbox] [data] [status] [NF] [peso] [volumes] [motorista] [email] [documento] [ações]
// Larguras calibradas pra acomodar o LABEL completo + ícone de busca,
// e ainda ter ellipsis se algum conteúdo de row passar do tamanho.
// Email é o único `1fr` — absorve o espaço restante da viewport.
// motorista e email usam 1fr (split do espaço sobrando), com mínimos pra não
// ficarem apertados quando a viewport é estreita. Email com 1.3fr porque
// emails costumam ser mais longos que nomes.
export const ORDER_GRID_COLS = '32px 195px 217px 100px 95px 100px minmax(200px, 1fr) minmax(220px, 1.3fr) 185px 200px'

export const TableWrap = styled.div`
  flex:1; overflow:auto; padding:0 20px 40px;
  &::-webkit-scrollbar { width:6px; height:6px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:3px; }
`
export const Table = styled.div`
  display:flex; flex-direction:column; width:100%; margin-top:12px;
  background:${c.bg2}; border:1px solid ${c.bdr}; border-radius:10px; overflow:hidden;
`
export const THead = styled.div` display:block; background:${c.bg3}; `
export const HRow = styled.div`
  display:grid; grid-template-columns: ${ORDER_GRID_COLS};
  background:${c.bg3};
  position:sticky; top:0; z-index:10;
  & > div {
    padding:10px 12px; font-size:10px;
    color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em;
    font-weight:600; border-bottom:1px solid ${c.bdr};
    white-space:nowrap;
    display:flex; align-items:center;
    min-width: 0;
    /* overflow visible: popover precisa transbordar pra baixo.
       O bleed entre colunas é controlado pelo flex-start do ColHead
       (label e ícone ficam juntos do lado esquerdo). */
    overflow: visible;
  }
`
export const Row = styled.div`
  display:grid; grid-template-columns: ${ORDER_GRID_COLS};
  transition:.12s;
  animation:${fadeIn} .15s ease;
  ${({ $selected }) => $selected && `background: rgba(0,229,160,.05);`}
  &:hover { background:${c.bg3}; }
  & > div {
    padding:11px 12px; font-size:12px;
    color:${c.txt}; display:flex; align-items:center;
    border-bottom:1px solid ${c.bdr};
    min-width: 0; overflow:hidden;
    white-space:nowrap; text-overflow:ellipsis;
  }
`

/* AccordionItem encapsula a Row + accordion expandido (border-bottom único). */
export const AccordionItem = styled.div`
  display:flex; flex-direction:column;
  border-bottom:1px solid ${c.bdr};
  &:last-child { border-bottom:none; }
  /* tira a borda interna da Row, deixando só a do AccordionItem */
  > div:first-child > div { border-bottom: none !important; }
`

export const CheckCell = styled.div`
  input { accent-color:${c.acc}; cursor:pointer; }
`
export const NfCell = styled.div`
  font-family:${c.mono}; font-weight:700; color:${c.acc};
`
export const NameCell = styled.div`
  max-width:240px;
  .name { color:${c.txt}; font-weight:500; }
  .addr { font-size:10px; color:${c.txt3}; margin-top:2px;
          white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
`
export const MonoCell = styled.div`
  font-family:${c.mono}; font-size:11px; color:${c.txt2};
  span.unit { color:${c.txt3}; font-size:10px; margin-left:3px; }
`
export const VolumesCell = styled.div`
  font-family:${c.mono}; font-size:11px;
  color:${({ $complete }) => $complete ? c.acc : c.txt2};
  .total { color:${c.txt3}; }
`

export const StatusBadge = styled.div`
  display:inline-flex; align-items:center; gap:5px;
  background:${({ $status }) => STATUS_COLORS[$status]?.bg || 'transparent'};
  border:1px solid ${({ $status }) => STATUS_COLORS[$status]?.border || c.bdr2};
  color:${({ $status }) => STATUS_COLORS[$status]?.text || c.txt3};
  padding:3px 9px; border-radius:11px;
  font-size:10px; font-weight:600;
  &::before {
    content:''; width:6px; height:6px; border-radius:50%;
    background:${({ $status }) => STATUS_COLORS[$status]?.border || c.txt3};
  }
`

export const Actions = styled.div`
  display:flex; gap:4px; justify-content:flex-end;
`
export const IconBtn = styled.button`
  background:transparent; border:1px solid ${c.bdr2}; border-radius:6px;
  width:28px; height:28px; cursor:pointer; transition:.12s;
  font-size:12px; color:${c.txt3}; padding:0;
  display:inline-flex; align-items:center; justify-content:center;
  &:hover {
    border-color:${({ $danger, $warn, $success }) =>
      $danger ? c.danger : $success ? c.acc : c.warn};
    color:${({ $danger, $warn, $success }) =>
      $danger ? c.danger : $success ? c.acc : c.warn};
    background:${({ $danger, $warn, $success }) =>
      $danger ? 'rgba(239,68,68,.08)' : $success ? c.adim : 'rgba(245,158,11,.08)'};
  }
  &:disabled { opacity:.4; cursor:not-allowed; pointer-events:none; }
`

// Botão de texto "Reentregar" na linha do pedido
export const ReentregaBtn = styled.button`
  background:transparent; border:1px solid ${c.warn}; color:${c.warn};
  height:28px; padding:0 9px; border-radius:6px; cursor:pointer; transition:.12s;
  font-size:11px; font-weight:600; font-family:${c.sans}; white-space:nowrap;
  display:inline-flex; align-items:center; gap:4px;
  &:hover { background:${c.warn}; color:#000; }
  &:disabled { opacity:.4; cursor:not-allowed; pointer-events:none; }
`

// Campos de formulário (usados no modal de reentrega)
export const FormLabel = styled.div`
  font-size:10px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em;
  margin:14px 0 6px;
`
export const FormInput = styled.input`
  width:100%; background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:10px 12px; font-size:13px; font-family:${c.sans}; outline:none;
  &:focus { border-color:${c.acc}; }
  &::placeholder { color:${c.txt3}; }
`
export const FormSelect = styled.select`
  width:100%; background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:10px 12px; font-size:13px; font-family:${c.sans}; outline:none; cursor:pointer;
  &:focus { border-color:${c.acc}; }
  option { background:${c.bg2}; color:${c.txt}; }
`

export const Empty = styled.div`
  text-align:center; padding:50px 20px; color:${c.txt3}; font-size:13px;
  background:${c.bg2}; border:1px dashed ${c.bdr2}; border-radius:10px;
  margin-top:12px;
  strong { color:${c.acc}; }
`
export const Loading = styled.div`
  text-align:center; padding:40px 20px; color:${c.txt3}; font-size:12px;
`

// ─── Column header (label + filter button + popover) ───────────────────────
export const ColHead = styled.div`
  /* flex-start mantém o ícone de busca colado ao label, mesmo se a coluna
     for mais larga que o conteúdo (caso "sem resultados"). */
  display:flex; align-items:center; justify-content:flex-start;
  width:100%; gap:6px; position:relative;
  overflow: visible;  /* popover precisa transbordar pra baixo */
  min-width: 0;
`
export const ColLabel = styled.span`
  font-size:10px; color:${c.txt3}; text-transform:uppercase;
  letter-spacing:.06em; font-weight:600;
  /* Trunca com ellipsis se o label não couber (segurança contra bleed). */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`
export const ColFilterBtn = styled.button`
  background:transparent; border:none; cursor:pointer;
  width:20px; height:20px; padding:0; border-radius:4px;
  display:inline-flex; align-items:center; justify-content:center;
  color:${({ $active }) => $active ? c.acc : c.txt3};
  transition:.12s; flex-shrink:0;
  &:hover { color:${c.acc}; background:${c.bg4}; }
  svg { width:13px; height:13px; stroke:currentColor; fill:none; stroke-width:2;
        stroke-linecap:round; stroke-linejoin:round; }
`
export const ColPopover = styled.div`
  position:absolute; top:calc(100% + 6px); right:0; z-index:100;
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:8px;
  padding:10px; min-width:240px;
  box-shadow:0 10px 32px rgba(0,0,0,.6);
  animation:${fadeIn} .12s ease;
  display:flex; flex-direction:column; gap:8px;
`
export const PopInput = styled.input`
  width:100%; background:${c.bg3}; border:1px solid ${c.bdr2};
  border-radius:6px; color:${c.txt}; padding:7px 10px;
  font-size:12px; font-family:${c.sans}; outline:none;
  &:focus { border-color:${c.acc}; }
  &::placeholder { color:${c.txt3}; }
`
export const PopDateRow = styled.div`
  display:flex; align-items:center; gap:6px;
  input[type="date"] {
    flex:1; background:${c.bg3}; border:1px solid ${c.bdr2};
    border-radius:6px; color:${c.txt}; padding:6px 8px;
    font-size:11px; font-family:${c.mono}; outline:none;
    color-scheme: dark;
    &:focus { border-color:${c.acc}; }
  }
  span { color:${c.txt3}; font-size:11px; }
`
export const PopCheckList = styled.div`
  display:flex; flex-direction:column; gap:5px;
  max-height:180px; overflow-y:auto;
  &::-webkit-scrollbar { width:4px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:2px; }
  label {
    display:flex; align-items:center; gap:7px; padding:4px 6px;
    border-radius:5px; cursor:pointer; font-size:12px; color:${c.txt};
    &:hover { background:${c.bg3}; }
    input { accent-color:${c.acc}; }
  }
`
export const PopActions = styled.div`
  display:flex; justify-content:space-between; gap:6px; margin-top:2px;
  border-top:1px solid ${c.bdr}; padding-top:8px;
`
export const PopBtn = styled.button`
  padding:5px 12px; border-radius:5px; cursor:pointer;
  font-size:11px; font-weight:600; font-family:${c.sans}; transition:.12s;
  background:${({ $primary }) => $primary ? c.acc : 'transparent'};
  border:1px solid ${({ $primary }) => $primary ? c.acc : c.bdr2};
  color:${({ $primary }) => $primary ? '#000' : c.txt2};
  &:hover { ${({ $primary }) => $primary ? 'filter:brightness(1.1);' : `border-color:${c.acc}; color:${c.acc};`} }
`

// ─── Pagination ───────────────────────────────────────────────────────────
export const PaginationBar = styled.div`
  display:flex; align-items:center; justify-content:space-between;
  gap:12px; padding:10px 14px; background:${c.bg2};
  border-top:1px solid ${c.bdr};
  flex-shrink:0;
  .info { font-size:11px; color:${c.txt3}; font-family:${c.mono}; }
  .nav { display:flex; align-items:center; gap:4px; }
`
export const PageBtn = styled.button`
  min-width:30px; height:28px; padding:0 8px;
  background:${({ $active }) => $active ? c.adim2 : c.bg3};
  border:1px solid ${({ $active }) => $active ? c.acc2 : c.bdr2};
  color:${({ $active }) => $active ? c.acc : c.txt2};
  border-radius:6px; cursor:pointer; font-size:11px; font-weight:600;
  font-family:${c.mono}; transition:.12s;
  &:hover:not(:disabled) { border-color:${c.acc}; color:${c.acc}; }
  &:disabled { opacity:.4; cursor:not-allowed; }
`
/* ─── Accordion expanded volumes panel (estilo Entregas) ───────────────── */
export const ExpandToggle = styled.button`
  background:transparent; border:none; cursor:pointer;
  color:${c.txt3}; width:24px; height:24px; padding:0;
  display:inline-flex; align-items:center; justify-content:center;
  font-size:12px; transition:.15s;
  transform: ${({ $open }) => $open ? 'rotate(180deg)' : 'rotate(0)'};
  &:hover { color:${c.acc}; }
`
export const VolumesAccordion = styled.div`
  background: ${c.bg3}; border-top: 1px solid ${c.bdr};
  padding: 14px 18px;
  > h5 { font-size:11px; font-weight:600; color:${c.txt3};
         text-transform:uppercase; letter-spacing:.05em; margin-bottom:10px; }
`
export const VolumeGrid = styled.div`
  display:grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 6px;
`
export const VolumeChip = styled.div`
  display:flex; align-items:center; gap:10px;
  background:${({ $status }) =>
    $status === 'embarcado' ? 'rgba(0,229,160,.06)' :
    $status === 'entregue' ? 'rgba(0,184,122,.10)' :
    $status === 'coletado' ? 'rgba(59,130,246,.06)' :
    $status === 'nao_embarcado' ? 'rgba(239,68,68,.08)' :
    c.bg2};
  border:1px solid ${({ $status }) =>
    $status === 'embarcado' ? '#00b87a' :
    $status === 'entregue' ? '#00b87a' :
    $status === 'coletado' ? '#3b82f6' :
    $status === 'nao_embarcado' ? '#ef4444' :
    c.bdr};
  border-left:3px solid ${({ $status }) =>
    $status === 'embarcado' ? '#00b87a' :
    $status === 'entregue' ? '#00b87a' :
    $status === 'coletado' ? '#3b82f6' :
    $status === 'nao_embarcado' ? '#ef4444' :
    '#5a6370'};
  border-radius:7px; padding:8px 10px;
  .num {
    background: ${c.bg2}; color: ${c.txt};
    border:1px solid ${c.bdr2};
    border-radius:5px; padding:2px 7px;
    font-family:${c.mono}; font-size:11px; font-weight:700;
    min-width:32px; text-align:center;
  }
  .body { flex:1; min-width:0; }
  .rastreio { font-family:${c.mono}; font-size:11px; color:${c.txt};
              white-space:nowrap; overflow:hidden; text-overflow:ellipsis; font-weight:600; }
  .meta { font-size:9px; color:${c.txt3}; margin-top:2px;
          white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .beep { font-size:9px; color:${c.txt2}; margin-top:2px; }
`

export const PerPageSelect = styled.select`
  background:${c.bg3}; border:1px solid ${c.bdr2}; color:${c.txt};
  padding:5px 8px; border-radius:6px; font-size:11px;
  font-family:${c.sans}; cursor:pointer; outline:none;
  &:focus { border-color:${c.acc}; }
  option { background:${c.bg2}; color:${c.txt}; }
`

// ─── Filter Drawer (lateral) ──────────────────────────────────────────────
export const FilterToggleBtn = styled.button`
  background:${({ $active }) => $active ? c.adim : c.bg3};
  border:1px solid ${({ $active }) => $active ? c.acc2 : c.bdr2};
  color:${({ $active }) => $active ? c.acc : c.txt2};
  padding:9px 14px; border-radius:8px; cursor:pointer;
  font-size:12px; font-family:${c.sans}; font-weight:500;
  display:inline-flex; align-items:center; gap:7px; transition:.15s;
  &:hover { border-color:${c.acc}; color:${c.acc}; }
  svg { width:14px; height:14px; stroke:currentColor; fill:none; stroke-width:2;
        stroke-linecap:round; stroke-linejoin:round; }
  .badge {
    background:${c.acc}; color:#000; font-weight:700;
    border-radius:10px; padding:1px 7px; font-size:9px;
    font-family:${c.mono}; min-width:18px; text-align:center;
  }
`
export const DrawerBackdrop = styled.div`
  position:fixed; inset:0; z-index:2500;
  background:rgba(0,0,0,.55); backdrop-filter:blur(2px);
  display:${({ $visible }) => $visible ? 'block' : 'none'};
  animation:${fadeIn} .15s ease;
`
export const Drawer = styled.aside`
  position:fixed; top:0; right:0; bottom:0; z-index:2501;
  width:480px; max-width:100vw;
  background:${c.bg2}; border-left:1px solid ${c.bdr};
  display:flex; flex-direction:column;
  transform:translateX(${({ $visible }) => $visible ? '0' : '100%'});
  transition: transform .25s cubic-bezier(.4,0,.2,1);
  box-shadow:-12px 0 32px rgba(0,0,0,.4);
`
export const DrawerHeader = styled.div`
  display:flex; align-items:center; justify-content:space-between;
  padding:18px 22px 14px; border-bottom:1px solid ${c.bdr};
  h3 { font-size:15px; font-weight:600; color:${c.txt}; }
  .close {
    background:none; border:none; color:${c.txt3}; cursor:pointer;
    width:28px; height:28px; border-radius:6px; font-size:18px;
    display:inline-flex; align-items:center; justify-content:center;
    &:hover { background:${c.bg3}; color:${c.txt}; }
  }
`
export const DrawerBody = styled.div`
  flex:1; overflow-y:auto; padding:18px 22px;
  display:flex; flex-direction:column; gap:16px;
  &::-webkit-scrollbar { width:5px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:3px; }
`
export const DrawerField = styled.div`
  display:flex; flex-direction:column; gap:6px;
  .lbl { font-size:11px; color:${c.txt3}; text-transform:uppercase;
         letter-spacing:.05em; font-weight:600; }
  .hint { font-size:10px; color:${c.txt3}; }
`
export const DrawerInput = styled.input`
  width:100%; background:${c.bg3}; border:1px solid ${c.bdr2};
  border-radius:7px; color:${c.txt}; padding:9px 12px;
  font-size:12px; font-family:${c.sans}; outline:none;
  &:focus { border-color:${c.acc}; }
  &::placeholder { color:${c.txt3}; }
`
export const DrawerDateRow = styled.div`
  display:flex; align-items:center; gap:8px;
  input[type="date"] {
    flex:1; background:${c.bg3}; border:1px solid ${c.bdr2};
    border-radius:7px; color:${c.txt}; padding:8px 10px;
    font-size:12px; font-family:${c.mono}; outline:none;
    color-scheme: dark;
    &:focus { border-color:${c.acc}; }
  }
  span { color:${c.txt3}; font-size:12px; }
`
export const DrawerChips = styled.div`
  display:flex; flex-wrap:wrap; gap:6px;
`
export const DrawerChip = styled.button`
  background:${({ $active }) => $active ? c.adim2 : 'transparent'};
  border:1px solid ${({ $active }) => $active ? c.acc2 : c.bdr2};
  color:${({ $active }) => $active ? c.acc : c.txt2};
  border-radius:14px; padding:5px 12px;
  font-size:11px; font-weight:500; cursor:pointer; transition:.12s;
  font-family:${c.sans};
  &:hover { border-color:${c.acc}; color:${c.acc}; }
`
export const DrawerFooter = styled.div`
  border-top:1px solid ${c.bdr}; padding:14px 22px;
  display:flex; justify-content:flex-end; gap:8px;
`

// ─── Modal Overlay (compartilhado) ─────────────────────────────────────────
export const ModalOverlay = styled.div`
  position:fixed; inset:0; z-index:2000;
  background:rgba(0,0,0,.6); backdrop-filter:blur(2px);
  display:${({ $visible }) => $visible ? 'flex' : 'none'};
  align-items:center; justify-content:center;
`

// ─── Modal de Import ────────────────────────────────────────────────────────
export const ImportBox = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:12px;
  padding:24px; width:540px; max-width:calc(100vw - 40px);
  box-shadow:0 16px 48px rgba(0,0,0,.7);
  h3 { font-size:16px; font-weight:600; margin-bottom:6px; color:${c.txt}; }
  p { font-size:12px; color:${c.txt3}; margin-bottom:18px; line-height:1.5; }
`
export const DropZone = styled.div`
  position:relative;
  border:2px dashed ${({ $drag, $hasFile }) => $hasFile ? c.acc : $drag ? c.acc : c.bdr2};
  background:${({ $drag, $hasFile }) => $hasFile ? c.adim : $drag ? c.adim : c.bg3};
  border-radius:10px; padding:30px 20px;
  text-align:center; transition:.18s;
  cursor:pointer;
  input[type="file"] {
    position:absolute; inset:0; opacity:0; cursor:pointer;
  }
  .icon { font-size:42px; margin-bottom:10px; }
  h4 { font-size:14px; font-weight:600; color:${c.txt}; margin-bottom:4px; }
  p { font-size:11px; color:${c.txt3}; margin:0; }
`
export const FileInfo = styled.div`
  margin-top:14px; padding:12px 14px;
  background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  display:flex; align-items:center; gap:10px;
  .meta { flex:1; }
  .name { font-size:12px; color:${c.txt}; font-weight:500; }
  .size { font-size:10px; color:${c.txt3}; margin-top:2px; font-family:${c.mono}; }
  .ok { color:${c.acc}; font-family:${c.mono}; font-weight:700; font-size:11px; }
`
export const ImportProgress = styled.div`
  margin-top:14px; padding:12px;
  background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  font-size:11px; color:${c.txt2}; font-family:${c.mono};
`

// ─── Modal de Ocorrências (resultado do bulk) ──────────────────────────────
export const OccBox = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:12px;
  padding:22px 24px; width:600px; max-width:calc(100vw - 40px);
  max-height:80vh; display:flex; flex-direction:column;
  box-shadow:0 16px 48px rgba(0,0,0,.7);
  h3 { font-size:15px; font-weight:600; color:${c.txt}; margin-bottom:14px; }
`
export const OccSummary = styled.div`
  display:grid; grid-template-columns: repeat(3, 1fr); gap:8px; margin-bottom:14px;
`
export const OccSummaryCard = styled.div`
  background:${c.bg3}; border-radius:8px; padding:10px 12px;
  border-left:3px solid ${({ $variant }) =>
    $variant === 'created' ? c.acc :
    $variant === 'ignored' ? c.warn :
    c.txt3};
  .l { font-size:10px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.05em; }
  .v { font-family:${c.mono}; font-size:18px; font-weight:700; color:${c.txt}; }
`
export const OccList = styled.div`
  flex:1; overflow-y:auto; padding-right:4px;
  &::-webkit-scrollbar { width:4px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:2px; }
`
// Motivos "acionáveis" pelo operador (amarelo) x erros/bloqueios (vermelho).
// volumes_sem_primeiro_bipe = coleta barrada porque falta o 1o bipe do volume.
const OCC_WARN = ['duplicate', 'volumes_sem_primeiro_bipe', 'volumes_nao_coletados']
const OCC_DANGER = ['invalid', 'invalid_transition', 'not_found']
const occTone = ($reason, warn, danger, neutral) =>
  OCC_WARN.includes($reason) ? warn :
  OCC_DANGER.includes($reason) ? danger :
  neutral

export const OccItem = styled.div`
  background:${c.bg3}; border:1px solid ${c.bdr};
  border-left:3px solid ${({ $reason }) => occTone($reason, c.warn, c.danger, c.txt3)};
  border-radius:7px; padding:8px 12px; margin-bottom:6px;
  display:flex; align-items:center; gap:10px;
  .nf { font-family:${c.mono}; font-weight:700; font-size:11px; color:${c.txt}; min-width:80px; }
  .msg { flex:1; font-size:11px; color:${c.txt2}; }
  .tag { font-size:9px; padding:2px 7px; border-radius:8px; text-transform:uppercase;
         font-weight:700; letter-spacing:.05em;
         background:${({ $reason }) =>
           occTone($reason, 'rgba(245,158,11,.18)', 'rgba(239,68,68,.18)', 'rgba(94,99,112,.18)')};
         color:${({ $reason }) => occTone($reason, c.warn, c.danger, c.txt3)};
       }
`

// ─── Modal Editar Status ────────────────────────────────────────────────────
export const StatusModalBox = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:12px;
  padding:22px 24px; width:420px; max-width:calc(100vw - 40px);
  box-shadow:0 16px 48px rgba(0,0,0,.7);
  h3 { font-size:15px; font-weight:600; color:${c.txt}; margin-bottom:6px; }
  p { font-size:12px; color:${c.txt3}; margin-bottom:14px; line-height:1.5; }
`
export const StatusOptions = styled.div`
  display:flex; flex-direction:column; gap:8px;
`
export const StatusOption = styled.label`
  display:flex; align-items:center; gap:10px;
  background:${({ $checked }) => $checked ? c.adim : c.bg3};
  border:1px solid ${({ $checked, $status }) =>
    $checked ? (STATUS_COLORS[$status]?.border || c.acc) : c.bdr2};
  border-radius:8px; padding:11px 14px; cursor:pointer; transition:.12s;
  &:hover { border-color:${c.acc}; }
  input { accent-color:${c.acc}; }
  .lbl { font-size:13px; font-weight:600; color:${c.txt}; }
  .hint { font-size:10px; color:${c.txt3}; margin-top:2px; }
`

// ─── Modal Actions (compartilhado) ─────────────────────────────────────────
export const ModalActions = styled.div`
  display:flex; justify-content:flex-end; gap:8px; margin-top:18px;
`
export const ModalBtn = styled.button`
  padding:8px 18px; border-radius:7px; cursor:pointer;
  font-size:12px; font-weight:600; transition:.15s; font-family:${c.sans};
  background:${({ $primary, $danger }) =>
    $danger ? c.danger : $primary ? c.acc : 'transparent'};
  border:1px solid ${({ $primary, $danger }) =>
    $danger ? c.danger : $primary ? c.acc : c.bdr2};
  color:${({ $primary, $danger }) =>
    $danger ? '#fff' : $primary ? '#000' : c.txt2};
  &:hover { ${({ $primary, $danger }) =>
    ($primary || $danger) ? 'filter:brightness(1.1);' : `border-color:${c.acc}; color:${c.acc};`} }
  &:disabled { opacity:.5; cursor:not-allowed; }
`

// ─── Confirm Modal ──────────────────────────────────────────────────────────
export const ConfirmBox = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:12px;
  padding:22px 24px; min-width:340px; max-width:440px;
  box-shadow:0 16px 48px rgba(0,0,0,.7);
  border-top:3px solid ${({ $tone }) => $tone === 'danger' ? c.danger : c.warn};
`
export const ConfirmIcon = styled.div`
  width:42px; height:42px; border-radius:50%;
  background:${({ $tone }) => $tone === 'danger' ? 'rgba(239,68,68,.15)' : 'rgba(245,158,11,.15)'};
  color:${({ $tone }) => $tone === 'danger' ? c.danger : c.warn};
  display:flex; align-items:center; justify-content:center;
  font-size:22px; margin-bottom:12px;
`
export const ConfirmTitle = styled.h3`
  font-size:15px; font-weight:600; color:${c.txt}; margin-bottom:6px;
`
export const ConfirmMessage = styled.p`
  font-size:12px; color:${c.txt2}; line-height:1.6; margin-bottom:18px;
  white-space:pre-line;
`
